import { Stack, HStack, IconButton, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { CalendlyEventListener, InlineWidget } from "react-calendly";
import { useHistory } from "react-router-dom";
import { Icon } from "../../components/Icon";
import { useStores } from "../../hooks/useStores";
import { BookingEvents } from "../../types";

export const MobileBookPersonaTrainerInactiveSubscription: React.FC = observer(
  () => {
    const { session } = useStores();
    const history = useHistory();

    const onEventScheduled = useCallback(
      (event: MessageEvent) => {
        console.log(event);
        const data: {
          event: string; // calendly.event_scheduled
          payload: {
            event: {
              uri: string; // "https://api.calendly.com/scheduled_events/CKAFHPPSNOW7Y4VL"
            };
            invitee: {
              uri: string; // "https://api.calendly.com/scheduled_events/CKAFHPPSNOW7Y4VL/invitees/HLCRWVIVCQNTSSUG"
            };
          };
        } = event.data;

        session.traceReservation({
          dateTime: new Date(), // temp. date
          externalId: data.payload.event.uri.split("/").pop(), // Calendly event ID
          source: "calendly",
          type: data.event,
          eventMeta: data.payload,
          bookingEvent:
            BookingEvents.BOOK_PERSONAL_TRAINER_INACTIVE_SUBSCRIPTION,
        });
      },
      [session]
    );

    return (
      <Stack marginLeft="1rem" position="fixed" backgroundColor="white" top="0">
        <HStack>
          <IconButton
            aria-label="Back"
            icon={<Icon iconName={"HiX"} />}
            variant={"ghost"}
            onClick={() => history.push("/client/board")}
          />
          <Stack>
            <Text fontSize="3xl">Prenotazione Personal Trainer</Text>
          </Stack>
        </HStack>
        <CalendlyEventListener onEventScheduled={onEventScheduled}>
          <InlineWidget
            prefill={{
              name: `${session.user?.name} ${session.user?.surname}`,
              firstName: session.user?.name,
              lastName: session.user?.surname,
              email: session.user?.email,
            }}
            url={
              session.calendlyBookPersonalTrainerInctiveSubscription?.value ||
              ""
            }
          />
        </CalendlyEventListener>
      </Stack>
    );
  }
);
